module.exports = __webpack_public_path__ + "img/phone_active.94ba0e2f.svg";